import { TopicCoreBase } from "./topic.core.base"


export class TopicCore extends TopicCoreBase {

}